module.exports = __webpack_public_path__ + "fonts/ClashDisplay-Semibold.fe7b20e.ttf";